import axios from "axios";
import { waitForReferralCapture } from "../referralCapture";

export const startCheckout = async (products: any, email: string, cancelURL: string, promocode: string) => {
    const data = {
        products: products,
        error_url: cancelURL,
        customer_email: email,
        promocode: promocode
    }

    await waitForReferralCapture();
    return await axios.post(`/api/payment/start`, data, { withCredentials: true })
}

export const getPricing = async (checkoutID: any) => {
    return axios.get(`/api/payment/pricing/${checkoutID}`)
}

export interface PurchaseTracking {
    value: number;
    currency: string;
    event_id: string;
}

export const getPurchaseTracking = (checkoutID: string) =>
    axios.get<PurchaseTracking | null>(`/api/payment/pricing/${checkoutID}`, {
        params: { tracking: true },
    });
